export const PROFILE_ADD = "profile/add";
export const PROFILE_GET = "profile/get";
export const PROFILE_ERROR = "profile/error";
